const MAX_PERCENTAGE = 95.7;

/**
 * Handles bike icon movement and progress line width adjustment.
 */
class BikeSlider {
  private container: HTMLElement;
  private icon: HTMLElement;
  private filledBar: HTMLElement;
  private remainingBar: HTMLElement;
  private maxValue: number;

  constructor() {
    this.container     = document.getElementById('selected-product')!;
    this.icon          = this.container.querySelector('.fa-person-biking')!;
    this.filledBar     = this.container.querySelector('.bike-progress__filled')!;
    this.remainingBar  = this.container.querySelector('.bike-progress__remaining')!;
    this.maxValue      = this.getMaxCapacity();
  }

  /**
   * Finds the highest data-capacity among available inputs.
   */
  private getMaxCapacity(): number {
    const radios = document.querySelectorAll<HTMLInputElement>('input[name="product_id"][data-capacity]');
    return Math.max(...Array.from(radios).map(r => parseFloat(r.dataset.capacity || '0')));
  }

  /**
   * Moves the bike and fills the line up to its front wheel.
   */
  public moveTo(value: number): void {
    const iconWidthPx = 32;
    const frontOffset = iconWidthPx * 0.9;
  
    const containerWidth = this.container.offsetWidth;
  
    // Calculate how far (in %) the left edge of the bike can go without overflowing
    const maxBikePercent = ((containerWidth - iconWidthPx) / containerWidth) * 100;
  
    // Calculate ratio and capped percentage
    const ratio       = Math.min(value / this.maxValue, 1);
    const percentBike = ratio * maxBikePercent;
  
    // Move bike
    this.icon.style.left = `${percentBike}%`;
  
    // Fill to front of bike
    const bikeLeftPx   = (percentBike / 100) * containerWidth;
    const fillWidthPx  = bikeLeftPx + frontOffset;
  
    if (value >= this.maxValue) {
      this.filledBar.style.width      = '100%';
      this.remainingBar.style.display = 'none';
    } else {
      this.filledBar.style.width      = `${fillWidthPx}px`;
      this.remainingBar.style.display = '';
    }
  }

  /**
   * Listens to input changes and positions bike on initial selection.
   */
  public bind(): void {
    const radios = document.querySelectorAll<HTMLInputElement>('input[name="product_id"][data-capacity]');

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const value = parseFloat(radio.dataset.capacity || '0');
        this.moveTo(value);
      });
    });

    const selected = Array.from(radios).find(r => r.checked);
    if (selected) {
      const initial = parseFloat(selected.dataset.capacity || '0');
      this.moveTo(initial);
    }
  }
}

/**
 * Initializes the BikeSlider on load and after #products reloads.
 */
function initBikeSlider() {
  try {
    const slider = new BikeSlider();
    slider.bind();
  } catch {
    // Fail silently if DOM is not ready
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initBikeSlider();

  const products = document.getElementById('products');
  const parent   = products?.parentElement;

  if (parent) {
    const observer = new MutationObserver(() => {
      initBikeSlider();
    });

    observer.observe(parent, { childList: true, subtree: true });
  }
});
